import React from 'react';
import styled, { css } from 'styled-components/macro';
import {Link} from 'react-router-dom';
import {menuData} from '../data/MenuData';
import { Button } from './Button';
import { FaBars} from 'react-icons/fa';

const Nav = styled.nav`
    height:60px;
    display:flex;
    justify-content:space-between;
    padding: 1rem 2rem;
    width:100%;
    position:sticky;
    z-index: 100;
    background:red;
`;

const NavLink = css`
color: #fff;
display:flex;
align-items:center;
padding:0 1rem;
height:100%;
cursor:pointer;
text-decoration:none;
`;

const Logo = styled(Link)`
${NavLink};
font-style:italic;
`;

const Menubars = styled(FaBars)`
display:None;

@media screen and (max-width:760px){
  display:block;
  position:absolute;
  top:0;
  right:0;
  cursor:pointer;
  height:30px;
  width:40px;
  transform:translate(-70%,55%);
  color:white;
}
`;

const NavMenu = styled.div`
display:flex;
align-items:center;
margin-right:-48px;

@media screen and (max-width:760px){
  display:none;
}
`;

const NavMenuLinks = styled(Link)`
${NavLink}
`;

const NavBtn = styled.div`
  display:flex;
  align-items:center;
  margin-right:24px;

  @media screen and (max-width:760px){
    display:none;
  }
`;

const Navbar = () => {
  return (
    <Nav>
        <Logo to='/'>REALVILLA</Logo>
        <Menubars />
        <NavMenu>
            {menuData.map((item,index)=>(
                <NavMenuLinks to={item.Link} key={index}>
                    {item.title}
                </NavMenuLinks>
            ))}
        </NavMenu>
        <NavBtn>
          <Button to='/contact' primary='true'>Contact Us</Button>
        </NavBtn>
    </Nav>
  )
}

export default Navbar